(function () {
    'use strict';

    angular
        .module('uwAgenda.global')
        .directive('fileupload', FileUploadFn);

    /* file upload directive */
    FileUploadFn.$inject = ['FileUploader'];

    //basic file-upload without filters
    function FileUploadFn(FileUploader) {
        var directive = {
            scope: {
                uploadurl: "@"
            },
            restrict: 'E',
            replace: true,
            template: '<input type="file" nv-file-select uploader="uploader" />',
            compile: function () {
                return {
                    pre: function (scope, element, attrs) {
                        scope.uploader = new FileUploader({
                            url: scope.uploadurl,
                            autoUpload: true,
                            removeAfterUpload: true
                        });

                        scope.uploader.onErrorItem = function (item, response, status, headers) {
                            alert("Failed to upload file: " + status + " " + response);
                        };
                    }
                };
            }
        };
        return directive;
    }
})();